export default "__VITE_ASSET__CwaxJB84__"